import { IonButton, IonModal } from "@ionic/react";
import { BIH_MAX_ORDER_PRICE_KM, BIH_PRICE_LIMIT_MESSAGE } from "../../common/constants";

interface Props {
  isOpen: boolean;
  formattedPriceKM: string;
  priceTotalKM: number;
  onDismiss: () => void;
}

export const BihPriceWarning: React.FC<Props> = ({
  isOpen,
  formattedPriceKM,
  priceTotalKM,
  onDismiss,
}) => {
  const overLimit = priceTotalKM > BIH_MAX_ORDER_PRICE_KM;
  const textColor = overLimit ? "var(--ion-color-danger)" : undefined;

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onDismiss} className="cart-modal">
      <div style={{ padding: "24px", textAlign: "center" }}>
        <h2 style={{ margin: "0 0 16px", color: textColor }}>
          {overLimit ? "Prekoračen limit za BIH" : "Limit za BIH"}
        </h2>
        <p style={{ margin: "0 0 16px", color: textColor, whiteSpace: "pre-line" }}>
          {BIH_PRICE_LIMIT_MESSAGE(formattedPriceKM).replace(/\n/g, "\n\n")}
        </p>
        <IonButton
          expand="block"
          fill="clear"
          color="medium"
          style={{ marginTop: 8 }}
          onClick={onDismiss}
        >
          Zatvori
        </IonButton>
      </div>
    </IonModal>
  );
};
